<template>
  <div>
    <b v-if="title">{{ title }}</b>
    <div style="display: flex;">
      <div>
        <table>
          <thead>
            <tr>
              <th></th>
              <th class="text-right">
                Produção
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="row-divider">
              <td>Informado</td>
              <td class="text-right">R$ {{ valorInformadoProcessado | formatPrice }}</td>
            </tr>
            <tr class="row-divider">
              <td>Pago</td>
              <td class="text-right green--text">R$ {{ valorPagoProcessado | formatPrice }}</td>
            </tr>
            <tr>
              <td>Glosado</td>
              <td class="text-right red--text">R$ {{ valorGlosadoProcessado | formatPrice }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="showRecursoTable" class="pl-2">
        <table id="recurso">
          <thead>
            <tr>
              <th></th>
              <th class="text-right">
                Recurso
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="row-divider">
              <td>Recursado</td>
              <td class="text-righ">R$ {{ valorRecursadoProcessado | formatPrice }}</td>
            </tr>
            <tr class="row-divider">
              <td>Pago</td>
              <td class="text-right green--text">R$ {{ valorPagoRecursoProcessado | formatPrice }}</td>
            </tr>
            <tr>
              <td >Glosa mantida</td>
              <td class="text-right red--text">R$ {{ valorGlosadoRecursoProcessado | formatPrice }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String || null,
    valorInformadoProcessado: Number,
    valorPagoProcessado: Number,
    valorGlosadoProcessado: Number,
    valorRecursadoProcessado: Number,
    valorPagoRecursoProcessado: Number,
    valorGlosadoRecursoProcessado: Number,
    showRecursoTable: Boolean
  }
}
</script>

<style scoped>
p {
  margin-top: 12px;
  font-weight: 700;
}

table, td {
  border: 1px solid white;
}

table {
  font-weight: 700;
}
thead {
  background-color: #EFF3F8;
}
th {
  border: solid 1px #EFF3F8;
  padding: 2px 8px;
}
td {
  padding: 2px 8px;
}
.row-divider td, tr{
  border-bottom: 1px solid #D1DCEA;
}
</style>
